import { NewObservationPhotos } from 'components/ObservationPhoto/components/NewObservationPhoto/NewObservationPhotos';
import OpportunityCategorisation from 'components/OpportunityCategorisation';
import OpportunityDetails from 'components/OpportunityDetails';
import React from 'react';
import OpportunityReporter from 'sections/opportunities-management/pages/ViewAmmendOpportunity/components/OpportunityReporter';
import {
    StyledPanelGrid,
    StyledPanelRow,
    StyledPanelColumn,
    StyledContainer
} from 'shared/styled/panel.stayled';
import { ObservationFileEntity } from 'shared/types/file/ObservationFileEntity';
import { IAddFiles } from 'shared/utils/files/types/IAddFiles';

interface NewOpportunityFormProps {
    handleAddFile: IAddFiles<ObservationFileEntity>;
    handleDeleteFile: (ids: string[]) => void;
}

const NewOpportunityForm = ({
    handleAddFile,
    handleDeleteFile
}: NewOpportunityFormProps) => {

    return (
        <React.Fragment>
            <StyledContainer>
                <StyledPanelGrid fluid>
                    <StyledPanelRow>
                        <StyledPanelColumn md={12} lg={4} xl={4}>
                            <OpportunityCategorisation readOnly={false} />
                        </StyledPanelColumn>
                        <StyledPanelColumn md={12} lg={4} xl={4}>
                            <OpportunityDetails readOnly={false} />
                            <NewObservationPhotos handleAddFile={handleAddFile} handleDeleteFile={handleDeleteFile} useEnglish />
                        </StyledPanelColumn>
                        <StyledPanelColumn md={12} lg={4} xl={4}>
                            <OpportunityReporter 
                                nearMissReadOnly={false} 
                                reporterReadOnly={false} 
                            />
                        </StyledPanelColumn>
                    </StyledPanelRow>
                </StyledPanelGrid>
            </StyledContainer>
        </React.Fragment>
    );
};

export default NewOpportunityForm;